module.exports = __webpack_public_path__ + "img/deco-paper-center.47326e7.png";